import { lazy } from 'react'

export const Home = lazy(() => import('./Home'))
export const AddToCart = lazy(() => import('./AddToCart'))
export const Cart = lazy(() => import('./Cart'))
export const Login = lazy(() => import('./Login'))
export const Checkout = lazy(() => import('./Checkout'))
export const VNPAYPaymentResult = lazy(() => import('./VNPAYPaymentResult'))
// export const PaymentSuccess = lazy(() => import('./PaymentSuccess'))
